module.exports = __webpack_public_path__ + "img/image-style-03.8d3be6e1.svg";